// import { useState, useEffect } from "react";
// import Date from "../../../../Components/Date";
// import {
//   getIncorrectAnswers,
//   updateAnswer,
//   deleteAnswer,
// } from "./../../../../REDUX/Models/answers.Model";
// import { createNotifi } from "../../../../REDUX/Models/notifi.Model";
// import { updateRating } from "../../../../REDUX/Models/users.Model";
// import { createCertificate } from "../../../../REDUX/Models/certificates.Model";
// import { useDispatch } from "react-redux";
// import { signOut } from "./../../../../REDUX/Slices/users.Slice";
// import "./index.scss";

// export default function Answers({ goBack }) {
//   const [answers, setAnswers] = useState([]);
//   // const [user, setUser] = useState({ notification: "", rating: "" });
//   const [userInputs, setUserInputs] = useState({});
//   const [text, setText] = useState(<i className="fa-light fa-paper-plane"></i>);
//   const dispatch = useDispatch();

//   // const handleChange = (e) => {
//   //   setUser({ ...user, [e.target.name]: e.target.value });
//   // };
//   const handleChange = (user_id, field, value) => {
//     setUserInputs((prev) => ({
//       ...prev,
//       [user_id]: {
//         ...prev[user_id],
//         [field]: value,
//       },
//     }));
//   };

//   const handleSubmit = (user_id) => {
//     const user = userInputs[user_id];
//     if (!user || user.notification?.length < 2 || !user.rating) return;

//     const trimmedNote = user.notification?.trim();
//     const validRating = user.rating !== null && user.rating !== "";

//     if (trimmedNote && validRating) {
//       createNotifi({ user_id: user_id, text: trimmedNote })
//         .then(() => updateRating({ user_id: user_id, rating: user.rating }))
//         .then(() => {
//           setUserInputs((prev) => ({
//             ...prev,
//             [user_id]: { notification: "", rating: "" },
//           }));
//           setText("تم الارسال.");
//           setTimeout(() => {
//             setText(<i className="fa-light fa-paper-plane"></i>);
//           }, 1000);
//         })

//         .catch(() => {
//           alert("خطأ انشاء نتيجة.");
//           dispatch(signOut());
//         });
//     } else {
//       alert("يرجى ملء الملاحظة والتقييم قبل الإرسال.");
//     }
//   };

//   const handleClick = (id, user_id, category_id) => {
//     updateAnswer({ id: id }).then(
//       createCertificate({ user_id: user_id, category_id: category_id })
//     );
//   };

//   const handleDelete = (id) => {
//     const confirmed = window.confirm("هل انت متأكد من حذف هذة الاجابة ؟");
//     if (confirmed) {
//       deleteAnswer(id).then();
//     }
//   };

//   useEffect(() => {
//     getIncorrectAnswers()
//       .then((res) => {
//         setAnswers(res.data.answers);
//       })
//       .catch(() => {
//         alert("خطأ عرض الاجابات");
//         dispatch(signOut());
//       });
//   }, [answers]);

//   return (
//     <div className="admin-answers">
//       <div className="container">
//         <header>
//           <h2>الاجابات</h2>
//           <p style={{ cursor: "pointer" }} onClick={goBack}>
//             اغلاق<i className="fa-light fa-x"></i>
//           </p>
//         </header>
//         <p>
//           * يرجى ارسال ملاحظة واضافة تقيم لكل متدرب في حالة النجاح او الرسوب ..
//           <span>عدد الاجابات: {answers.length}</span>
//         </p>
//         <div className="row">
//           <table>
//             {answers.length > 0
//               ? answers.map((answer, index) => {
//                   return (
//                     <tbody key={index}>
//                       <tr>
//                         <th className="head">السؤال: </th>
//                         <th>{answer.q1}</th>
//                         <th>{answer.q2}</th>
//                         <th>{answer.q3}</th>
//                         <th>{answer.q4}</th>
//                         <th>{answer.q5}</th>
//                         <th>ملاحظة</th>
//                         <th>ناجح </th>
//                         <th>راسب</th>
//                         <th>التاريخ</th>
//                       </tr>
//                       <tr className="answer">
//                         <th className="head">الاجابة: </th>
//                         <th>{answer.a1}</th>
//                         <th>{answer.a2}</th>
//                         <th>{answer.a3}</th>
//                         <th>{answer.a4}</th>
//                         <th>{answer.a5}</th>
//                         <th>
//                           <input
//                             type="text"
//                             placeholder="ارسال ملاحظة للمتدرب"
//                             value={
//                               userInputs[answer.user_id]?.notification || ""
//                             }
//                             onChange={(e) =>
//                               handleChange(
//                                 answer.user_id,
//                                 "notification",
//                                 e.target.value
//                               )
//                             }
//                           />
//                           <input
//                             type="number"
//                             placeholder="تقيم المتدرب"
//                             value={userInputs[answer.user_id]?.rating || ""}
//                             onChange={(e) =>
//                               handleChange(
//                                 answer.user_id,
//                                 "rating",
//                                 e.target.value
//                               )
//                             }
//                           />
//                           <button
//                             className="btn"
//                             onClick={() => handleSubmit(answer.user_id)}
//                           >
//                             {text}
//                           </button>
//                         </th>
//                         <th>
//                           <button
//                             className="success"
//                             onClick={() =>
//                               handleClick(
//                                 answer.id,
//                                 answer.user_id,
//                                 answer.category_id
//                               )
//                             }
//                           >
//                             ناجح
//                           </button>
//                         </th>
//                         <th>
//                           <button
//                             className="fail"
//                             onClick={() => handleDelete(answer.id)}
//                           >
//                             راسب
//                           </button>
//                         </th>
//                         <th>
//                           <Date date={answer.created_date} />
//                         </th>
//                       </tr>
//                       <tr className="separator-row">
//                         <td colSpan="10"></td>
//                       </tr>
//                     </tbody>
//                   );
//                 })
//               : "لا يوجد اجابات للعرض"}
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import Date from "../../../../Components/Date";
import {
  getIncorrectAnswers,
  updateAnswer,
  deleteAnswer,
} from "./../../../../REDUX/Models/answers.Model";
import { createNotifi } from "../../../../REDUX/Models/notifi.Model";
import { updateRating } from "../../../../REDUX/Models/users.Model";
import { createCertificate } from "../../../../REDUX/Models/certificates.Model";
import { useDispatch } from "react-redux";
import { signOut } from "./../../../../REDUX/Slices/users.Slice";
import "./index.scss";

export default function Answers({ goBack }) {
  const [answers, setAnswers] = useState([]);
  const [userInputs, setUserInputs] = useState({});
  const [submittingUserId, setSubmittingUserId] = useState(null);
  const dispatch = useDispatch();

  const handleChange = (user_id, field, value) => {
    setUserInputs((prev) => ({
      ...prev,
      [user_id]: {
        ...prev[user_id],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async (user_id) => {
    const user = userInputs[user_id];
    if (!user || user.notification?.trim().length < 2 || user.rating === "") {
      alert("يرجى ملء الملاحظة والتقييم قبل الإرسال.");
      return;
    }

    try {
      setSubmittingUserId(user_id);

      await createNotifi({ user_id, text: user.notification.trim() });
      await updateRating({ user_id, rating: user.rating });

      setUserInputs((prev) => ({
        ...prev,
        [user_id]: { notification: "", rating: "" },
      }));

      setTimeout(() => setSubmittingUserId(null), 1000);
    } catch {
      alert("خطأ في إرسال البيانات.");
      dispatch(signOut());
    }
  };

  const handleClick = async (id, user_id, category_id) => {
    try {
      await updateAnswer({ id });
      await createCertificate({ user_id, category_id });
      setAnswers((prev) => prev.filter((a) => a.id !== id));
    } catch {
      alert("حدث خطأ أثناء المعالجة.");
    }
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("هل انت متأكد من حذف هذة الاجابة ؟");
    if (!confirmed) return;

    try {
      await deleteAnswer(id);
      setAnswers((prev) => prev.filter((a) => a.id !== id));
    } catch {
      alert("خطأ في الحذف.");
    }
  };

  useEffect(() => {
    getIncorrectAnswers()
      .then((res) => setAnswers(res.data.answers))
      .catch(() => {
        alert("خطأ عرض الاجابات");
        dispatch(signOut());
      });
  }, [answers]);

  return (
    <div className="admin-answers">
      <div className="container">
        <header>
          <h2>الاجابات</h2>
          <p style={{ cursor: "pointer" }} onClick={goBack}>
            اغلاق<i className="fa-light fa-x"></i>
          </p>
        </header>
        <p>
          * يرجى ارسال ملاحظة واضافة تقيم لكل متدرب في حالة النجاح او الرسوب ..
          <span>عدد الاجابات: {answers.length}</span>
        </p>
        <div className="row">
          <table>
            {/* {answers.length > 0 ? (
              answers.map((answer) => (
                <tbody key={answer.id}>
                  <tr>
                    <th className="head">السؤال: </th>
                    <th>{answer.q1}</th>
                    <th>{answer.q2}</th>
                    <th>{answer.q3}</th>
                    <th>{answer.q4}</th>
                    <th>{answer.q5}</th>
                    <th>ملاحظة</th>
                    <th>ناجح</th>
                    <th>راسب</th>
                    <th>التاريخ</th>
                  </tr>
                  <tr className="answer">
                    <th className="head">الاجابة: </th>
                    <th>{answer.a1}</th>
                    <th>{answer.a2}</th>
                    <th>{answer.a3}</th>
                    <th>{answer.a4}</th>
                    <th>{answer.a5}</th>
                    <th>
                      <input
                        type="text"
                        placeholder="ارسال ملاحظة للمتدرب"
                        value={userInputs[answer.user_id]?.notification || ""}
                        onChange={(e) =>
                          handleChange(
                            answer.user_id,
                            "notification",
                            e.target.value
                          )
                        }
                      />
                      <input
                        type="number"
                        placeholder="تقيم المتدرب"
                        value={userInputs[answer.user_id]?.rating || ""}
                        onChange={(e) =>
                          handleChange(
                            answer.user_id,
                            "rating",
                            e.target.value
                          )
                        }
                      />
                      <button
                        className="btn"
                        onClick={() => handleSubmit(answer.user_id)}
                        disabled={submittingUserId === answer.user_id}
                      >
                        {submittingUserId === answer.user_id ? "جاري الإرسال..." : <i className="fa-light fa-paper-plane"></i>}
                      </button>
                    </th>
                    <th>
                      <button
                        className="success"
                        onClick={() =>
                          handleClick(
                            answer.id,
                            answer.user_id,
                            answer.category_id
                          )
                        }
                      >
                        ناجح
                      </button>
                    </th>
                    <th>
                      <button
                        className="fail"
                        onClick={() => handleDelete(answer.id)}
                      >
                        راسب
                      </button>
                    </th>
                    <th>
                      <Date date={answer.created_date} />
                    </th>
                  </tr>
                  <tr className="separator-row">
                    <td colSpan="10"></td>
                  </tr>
                </tbody>
              ))
            ) : (
              <tbody>
                <tr>
                  <td colSpan="10">لا يوجد اجابات للعرض</td>
                </tr>
              </tbody>
            )} */}

            {answers.length > 0 ? (
              answers.map((answer) => {
                const userInput = userInputs[answer.user_id] || {};

                return (
                  <tbody key={answer.id}>
                    <tr>
                      <th className="head">السؤال: </th>
                      <th>{answer.q1}</th>
                      <th>{answer.q2}</th>
                      <th>{answer.q3}</th>
                      <th>{answer.q4}</th>
                      <th>{answer.q5}</th>
                      <th>ملاحظة</th>
                      <th>ناجح</th>
                      <th>راسب</th>
                      <th>التاريخ</th>
                    </tr>
                    <tr className="answer">
                      <th className="head">الاجابة: </th>
                      <th>{answer.a1}</th>
                      <th>{answer.a2}</th>
                      <th>{answer.a3}</th>
                      <th>{answer.a4}</th>
                      <th>{answer.a5}</th>
                      <th>
                        <input
                          type="text"
                          placeholder="ارسال ملاحظة للمتدرب"
                          value={userInput.notification || ""}
                          onChange={(e) =>
                            handleChange(
                              answer.user_id,
                              "notification",
                              e.target.value
                            )
                          }
                        />
                        <input
                          type="number"
                          placeholder="تقيم المتدرب"
                          value={userInput.rating || ""}
                          onChange={(e) =>
                            handleChange(
                              answer.user_id,
                              "rating",
                              e.target.value
                            )
                          }
                        />
                        <button
                          className="btn"
                          onClick={() => handleSubmit(answer.user_id)}
                          disabled={submittingUserId === answer.user_id}
                        >
                          {submittingUserId === answer.user_id ? (
                            "جاري الإرسال..."
                          ) : (
                            <i className="fa-light fa-paper-plane"></i>
                          )}
                        </button>
                      </th>
                      <th>
                        <button
                          className="success"
                          onClick={() =>
                            handleClick(
                              answer.id,
                              answer.user_id,
                              answer.category_id
                            )
                          }
                        >
                          ناجح
                        </button>
                      </th>
                      <th>
                        <button
                          className="fail"
                          onClick={() => handleDelete(answer.id)}
                        >
                          راسب
                        </button>
                      </th>
                      <th>
                        <Date date={answer.created_date} />
                      </th>
                    </tr>
                    <tr className="separator-row">
                      <td colSpan="10"></td>
                    </tr>
                  </tbody>
                );
              })
            ) : (
              <tbody>
                <tr>
                  <td colSpan="10">لا يوجد اجابات للعرض</td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  );
}
